import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import MediumVoyant from "./components/MediumVoyant";
import Testimonials from "./components/Testimonials";
import Cities from "./components/Cities";
import CitiesSEO from "./components/CitiesSEO";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <MediumVoyant />
      <Testimonials />
      <Cities />
      <CitiesSEO />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;